import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import callApi from "helpers/callApi";
import { parseServerError } from "utils/errors";

export const fetchEprGuides = createAsyncThunk(
  "eprGuides/fetchEprGuides",
  async (_, { rejectWithValue }) => {
    try {
      const response = await callApi("/epr_guides", "GET");
      if (!response.ok) {
        return rejectWithValue(response.errorMessage || "Error");
      }
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return rejectWithValue(error?.message || "Error");
    }
  }
);

const initialState = {
  items: [],
  fetchingEprGuides: true,
  fetchEprGuidesError: null,
};

const eprGuidesSlice = createSlice({
  name: "eprGuides",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEprGuides.pending, (state) => {
        state.fetchingEprGuides = true;
        state.fetchEprGuidesError = null;
      })
      .addCase(fetchEprGuides.fulfilled, (state, action) => {
        state.fetchingEprGuides = false;
        state.fetchEprGuidesError = null;
        state.items = action.payload;
      })
      .addCase(fetchEprGuides.rejected, (state, action) => {
        state.fetchingEprGuides = false;
        state.fetchEprGuidesError = parseServerError(
          action.payload ?? action.error
        );
      });
  },
});

export default eprGuidesSlice.reducer;
